import Loading from './Loading.vue';

export default Loading;
